export default __webpack_public_path__ + "static/media/Modal_GIF.746bf26b.jpg";